/** @format */

const car_illustration =
  "https://nbg1.your-objectstorage.com/carlofty/dockie/8dcf6254-c1af-46fd-99ea-c79cd3e5b22e_car-illustration.svg";
const retailer_illustration =
  "https://nbg1.your-objectstorage.com/carlofty/dockie/5fb7f2aa-4516-48c6-bd61-b67c3379bbd4_retailers.svg";
const dealer_illustration =
  "https://nbg1.your-objectstorage.com/carlofty/dockie/6c96ce22-3e25-40f7-8eea-6fbb94ffdcb3_dealers.svg";

export { retailer_illustration, dealer_illustration, car_illustration };
